import DonutChart from "@/components/visualizations/DonutChart/DonutChart";
import { SingleBarChartData } from "@/components/visualizations/SingleBarChart.tsx/SingleBarChart";
import useTranslation from "@/hooks/useTranslation";
import Widget from "@/pages/dashboard/components/Widget/Widget";
import { facilityLabel } from "@/pages/dashboard/FacilityDashboard/widgets/FacilityImpactTopContributors";
import {
  ProductBy,
  useProductProductionImpactPerType,
} from "@/pages/dashboard/hooks/useProductImpact";
import { ImpactMetric } from "@/pages/dashboard/utils/types";

function ProductionImpactPerType({
  metric,
  productId,
  by,
}: {
  metric: ImpactMetric;
  productId: number;
  by: ProductBy;
}) {
  const { data, isLoading, isFetching } = useProductProductionImpactPerType({
    productId,
    by,
    metric: metric.key,
  });
  const translation = useTranslation();

  const chartData: SingleBarChartData = data
    ? data
        .map((row) => ({
          label: facilityLabel(row.energy_type) || "Unknown",
          value: row.impact[metric.key],
          order: row.energy_type === "Electricity" ? 1 : row.energy_type === "Water" ? 2 : 3,
        }))
        .sort((a, b) => (a.order < b.order ? -1 : 1))
    : [];

  return (
    <Widget
      title={translation["productDrawer"]["productionImpactByType"]["title"]}
      tooltip={translation["productDrawer"]["productionImpactByType"]["description"]}
    >
      <DonutChart
        data={chartData}
        format={metric.formatter}
        loading={isLoading || isFetching}
      />
    </Widget>
  );
}

export default ProductionImpactPerType;
